import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";
import tools from "../QS420_tools";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";

var backfillHistoryData = function backfillHistoryData(_this) {
  var creditInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  if (!_.isEmpty(creditInfo)) {
    _this.$blMethod.parseMoudleArray(_this, _this.groupDatas[GROUP_ID][MODULE_ID], creditInfo);
  }
  var credit = "TAX_INFO.CREDIT_INFO";
  var creditList = _.cloneDeepGet(_this, "" + credit) || [],
      creditListLen = creditList.length;
  if (creditListLen > 1) {
    for (var i = 0; i < creditListLen - 1; i++) {
      _.set(_this, credit + "[" + i + "].FIELDS.RECORD_SOURCE.FIELD_CONTROL", "2");
    }

    tools.addCreditModule(_this, creditList[creditListLen - 1], true);
  }
};

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  fields.RECORD_TXT.VALID_TYPE = "length[0,512]";
  var tempFields = _this.groupDatasTpl[GROUP_ID][MODULE_ID][0].FIELDS;
  tempFields.RECORD_TXT.VALID_TYPE = "length[0,512]";
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {

    initFieldConfig(_this);
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var creditInfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              creditInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH]);

              if (!_.isArray(creditInfo)) {
                creditInfo = [creditInfo];
              }

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], creditInfo);
              _.set(params, SAVE_PATH, creditInfo);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),

  "CHECK_RECORD_SOURCE": function CHECK_RECORD_SOURCE(_this, field, fieldData) {
    var creditModule = "groupDatas.TAX_INFO.CREDIT_INFO",
        creditList = _.get(_this, "" + creditModule);

    if (field.DEFAULT_VALUE != "ZZ") {
      fieldData.RECORD_TXT.FIELD_CONTROL = "0";
      fieldData.RECORD_TXT.FIELD_REQUIRED = "1";
    } else {
      fieldData.RECORD_TXT.FIELD_CONTROL = "2";
      fieldData.RECORD_TXT.FIELD_REQUIRED = "0";
      fieldData.RECORD_TXT.DEFAULT_VALUE = "";
    }

    if (creditList.length == 1) {
      if (field.DEFAULT_VALUE == "ZZ") {
        _.set(_this, creditModule + "[0].MODULE_ADD", "0");
      } else {
        _.set(_this, creditModule + "[0].MODULE_ADD", "1");
      }
    } else {
      if (field.DEFAULT_VALUE == "ZZ") {
        creditList.splice(1, creditList.length - 1);
      }
    }
  }
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizOther/bizOtherCreditInfoNode.js
// module id = 161
// module chunks = 2